module.exports = function () {
    const flowContents = document.querySelectorAll(".flow-content");
    if ( !flowContents.length ) return;
    console.log(flowContents);
    
    for (const flowContent of flowContents) {
        const popup = flowContent.querySelector(".flow-content-popup");
        const popupWrapper = flowContent.querySelector(".flow-content-popup__wrapper");
        const popupClose = flowContent.querySelector(".flow-content-popup__close-button");
        const popupContents = flowContent.querySelectorAll(".flow-content-popup__content");
        const buttons = flowContent.querySelectorAll("[data-button-index]");
        const navButtons = flowContent.querySelectorAll(".flow-content-popup__nav-button");

        buttons.forEach((button) => {
            const index = Number(button.dataset.buttonIndex);
            button.addEventListener("click", () => openPopup(index));
        })

        navButtons.forEach((navButton, index) => {
            navButton.addEventListener("click", () => switchContent(index));
        });

        popupClose?.addEventListener("click", closePopup);

        function switchContent(index) {
            popupContents.forEach((content, i) => content.classList.toggle("hidden", i !== index));
            navButtons.forEach((btn, i) => btn.classList.toggle("active", i === index));
        }

        function openPopup(index) {
            popup.classList.remove("opacity-0", "invisible");
            document.body.classList.add("overflow-hidden");
            popupContents.forEach((content, i) => content.classList.toggle("hidden", i !== index));
            navButtons.forEach((btn, i) => btn.classList.toggle("active", i === index));
            
            setTimeout(() => {
                document.addEventListener("click", closeOutsidePopup);
            })
        }
        
        function closePopup() {
            popup.classList.add("opacity-0", "invisible");
            document.body.classList.remove("overflow-hidden");
            
            document.removeEventListener("click", closeOutsidePopup);
        }
        
        function closeOutsidePopup(e) {
            if ( !popupWrapper?.contains(e.target) ) closePopup();
        }
    }
}